<template>
    <div class="match-block">
        <div class="match-block-column">
            {{ label }}
            <span v-if="required">*</span>
        </div>
        <div class="match-block-column quarter">
            <app-select
                v-model="tempValue"
                filterable
                placeholder="Select"
                clearable
                size="small"
                @change="handleChange">
                <app-option
                    v-for="(option, index) in options"
                    :key="index"
                    :label="option"
                    :value="option"/>
            </app-select>
        </div>
        <div class="match-block-column quarter">{{ firstRow[tempValue] }}</div>
    </div>
</template>

<script>
// eslint-disable-next-line
import string_score from 'string_score'
export default {
    name: 'matching-row',
    props: {
        value: {
            type: Object,
            default: function() {
                return {}
            }
        },
        label: String,
        options: {
            type: Array,
            default: function() {
                return []
            }
        },
        firstRow: {
            type: Object,
            default: function() {
                return {}
            }
        },
        field: String,
        required: {
            type: Boolean,
            default: true
        },
        lastMap: String,
        hasLastMap: Boolean
    },
    data() {
        return {
            tempValue: ''
        }
    },
    mounted() {
        //Uses last map value if in import header
        if (this.options.includes(this.lastMap)) {
            this.tempValue = this.lastMap
            this.handleChange(this.tempValue)
        }
        //Otherwise sets to null
        else {
            this.tempValue = null
            this.handleChange(this.tempValue)
        }
        //Only finds closest if its null and there is no last map
        if (this.tempValue == null && !this.hasLastMap) {
            this.tempValue = this.findClosest()
            this.handleChange(this.tempValue)
        }
    },
    methods: {
        handleChange(newValue) {
            this.value[this.field] = newValue
            this.$emit('input', this.value)
        },
        handleClear() {
            this.tempValue = null
            this.value[this.field] = null
            this.$emit('input', this.value)
        },
        findClosest() {
            const closest = this.options.reduce((closest, option) => {
                const score = this.label.score(option, 0.5)
                if (score > closest.score) {
                    return {
                        score: score,
                        value: option
                    }
                }
                return closest
            },
            {
                score: 0,
                value: null
            })

            if (closest.score > 0.5) {
                return closest.value
            }
            return null
        }
    }
}
</script>

<style lang="stylus"></style>

